import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContainer } from '../components/auth';

interface LocationState {
  redirectTo?: string;
  universityId?: number;
}

export const AuthPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState;

  const handleAuthSuccess = () => {
    // Si un redirectTo est spécifié dans l'état, on redirige vers cette page
    // Sinon, on redirige vers la page d'accueil
    if (state?.redirectTo) {
      // Si un universityId est spécifié, on l'ajoute à l'URL
      if (state.universityId) {
        navigate(`${state.redirectTo}${state.redirectTo.endsWith('/') ? '' : '/'}${state.universityId}`);
      } else {
        navigate(state.redirectTo);
      }
    } else {
      navigate('/');
    }
  };

  return (
    <div className="max-w-md mx-auto py-8">
      <h1 className="text-3xl font-bold text-secondary mb-6 text-center">Connexion</h1>
      <AuthContainer onAuthSuccess={handleAuthSuccess} />
    </div>
  );
};
